import React from 'react';
import Icon from '../../../components/AppIcon';

const FinancialSummary = ({ data }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Finansal Özet</h3>
        <Icon name="DollarSign" size={20} className="text-muted-foreground" />
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between pb-4 border-b border-border">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Toplam Harcama</p>
            <p className="text-2xl font-bold text-foreground">{data?.totalSpent}</p>
          </div>
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="TrendingUp" size={24} color="var(--color-primary)" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Aktif Kampanyalar</p>
            <p className="text-lg font-semibold text-foreground">{data?.activeCampaigns}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Komisyon</p>
            <p className="text-lg font-semibold text-foreground">{data?.commission}</p>
          </div>
        </div>

        <div className="pt-4 border-t border-border">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Bekleyen Ödemeler</span>
            <span className="text-sm font-semibold text-warning">{data?.pendingPayments}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Tamamlanan Ödemeler</span>
            <span className="text-sm font-semibold text-success">{data?.completedPayments}</span>
          </div>
        </div>

        <div className="pt-4 border-t border-border">
          <h4 className="text-sm font-semibold text-foreground mb-3">Son İşlemler</h4>
          <div className="space-y-3">
            {data?.recentTransactions?.map((transaction) => (
              <div key={transaction?.id} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    transaction?.type === 'payment' ? 'bg-error/10' : 'bg-success/10'
                  }`}>
                    <Icon
                      name={transaction?.type === 'payment' ? 'ArrowUpRight' : 'ArrowDownLeft'}
                      size={14}
                      color={transaction?.type === 'payment' ? 'var(--color-error)' : 'var(--color-success)'}
                    />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground">{transaction?.description}</p>
                    <p className="text-xs text-muted-foreground">{transaction?.date}</p>
                  </div>
                </div>
                <span className={`text-sm font-semibold ${
                  transaction?.type === 'payment' ? 'text-error' : 'text-success'
                }`}>
                  {transaction?.type === 'payment' ? '-' : '+'}{transaction?.amount}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialSummary;